import { getFileByChecksums } from "../digitalVault";
import { parseFiles } from '../utils';
export default async (checkSums) => {
    const checkumCollection = [];
    checkSums.forEach((sums) => {
        checkumCollection.push({
            "@checksum": sums.checksum,
            'repositoryName': [{
                    '$': [sums.repository]
                }]
        });
    });
    const { files } = await getFileByChecksums({
        checksumAndRepositoryNames: checkumCollection,
    });
    let nextPage = '';
    return {
        data: parseFiles(files),
        hasNextPage: !!nextPage,
        paginate() {
            return !!nextPage;
        },
    };
    // return files;
};
